import React, { useEffect, useState, useRef } from "react";

import "./detailGrille.css";
import "../DetailEval/detailEval.css";

import iconRightArrow from "../../../assets/images/icon-right-arrow.png";
import arrowupSelected from "../../../assets/images/arrow-up-selected.png";
import arrowdown from "../../../assets/images/arrow-down.png";

import { useDispatch, useSelector } from "react-redux";
import { closeDetailGrille } from "../../../redux/actions/design";
import clsx from "clsx";
import iconMoinScore from "../../../assets/images/moin-score.png";
import iconPlusScore from "../../../assets/images/plus-score.png";
import { Form, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import iconLike from "../../../assets/images/like-icon.png";
import iconDislike from "../../../assets/images/dislike-icon.png";
import iconChat from "../../../assets/images/icon-chat.svg";
import iconInfo from "../../../assets/images/icon-info.svg";
import AttributsIcon from "../../../assets/images/IconeAttrb.png";
import BarColorized from "../../../assets/images/field.svg";



import { array } from "yup";
import PopoverBonus from "./PopoverBonus";
import Popovermalus from "./Popovermalus";

const DetailGrille = (props) => {
  const overlayChatRef = useRef(null);
  const [closeAnimation, setCloseAnimation] = useState(false);
  const { isOpenDetailGrille } = useSelector((state) => state.design);
  const [showOverlayChat, setShowOverlayChat] = useState(false); 
  const [showAllValues, setShowAllValues] = useState(false);
  const [expandedAttributes, setExpandedAttributes] = useState({});
  const [currentDesc, setCurrentDesc] = useState(null);
  const { datagrille } = useSelector((state) => state.grille);
  const [show, setShow] = useState(true)
  const dispatch = useDispatch();
  const [colorParam, setColorParam] = useState({
    id: 1,
    color: null,
    name: null,
  });
  const [displayParam, setDisplayParam] = useState({
    status: false,
    id: 0,
    id2: 0
  });

  const handelbonu = (id, key1) => {

    let filtere = props.selected ? props.e.CriteriaGroup.filter((e) => (e.id === id)) : datagrille?.grid?.CriteriaGroup.filter((e) => (e.id === id))

    let array = filtere[0]?.Criteria && filtere[0]?.Criteria.map((e) => (e.CriteriaOption.map(e => (e.CriteriaOptionValue))))
    // let array=  filtere[0].Criteria.map((e)=>(e.CriteriaValue))
    let array2 = filtere[0]?.Criteria && filtere[0]?.Criteria.map((e) => (e.CriteriaOption.map(e => (e))))

    let name = array2
    let content = array[0]
    return ({ content, name })
  }

  const popoverChat =
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      {props.selected ? (
        <Form.Control className="textarea-comment" as="textarea" rows={3} placeholder={currentDesc} />

      ) : (
        <Form.Control className="textarea-comment" as="textarea" rows={3} placeholder={`${currentDesc}`} />

      )}
    </Tooltip>
    ;


  return (
    props.selected ? (
      <div
        className={clsx(
          { "detail-grille-container": isOpenDetailGrille },
          { "detail-grille-containe-close": closeAnimation }
        )}
      >
        {!props.selected &&
          <div
            className="left-side-detail-grille"
            onClick={() => {


              setCloseAnimation(true);

              setTimeout(() => {
                dispatch(closeDetailGrille());
              }, 2000);
            }}
          ></div>}
        <div className={!props.selected ? " right-side-detail-grille" : "side-detail-grille"}>
          <div className="container-topbar-of-callibrage">
            <div
              className="container-icon-arraw-left"
              onClick={() => {
                setCloseAnimation(true);

                setTimeout(() => {
                  dispatch(closeDetailGrille());
                }, 2000);
              }}
            >
              <img src={iconRightArrow} />
            </div>
            {!props.selected ? <p style={{ marginBottom: "0" }} > Détails grille :  <span >{props.e.name}</span> </p> : <p style={{ marginBottom: "0" }} > Details  grilles :  <span >{props.e.name}</span> </p>}

          </div>

          <div id="detail-grille-bottom-side">
            <div className="container-of-right-side">
              <div >

                {props.e.CriteriaGroup && props.e.CriteriaGroup.map(function (val, idkey) {
                  return (
                    <div>

                      <div className="detail-grille_title mb-2">
                        <span >{val.name}</span>
                      </div>


                      {val.Criteria.map((val1, key1) =>
                      (
                        <div
                          key={idkey}
                          className="detail-grille_title containers-of-grids-details mb-1"
                        >
                          <div
                            style={{ minWidth: "100px" }}
                            onClick={() =>

                              setDisplayParam({ status: false, id: 0 })

                            }
                          >
                            {val1.name}
                          </div>
                          <div className="row">
                            {val1.CriteriaValue && val1.CriteriaValue.sort((a,b)=> {return (a.idCriteriaValue - b.idCriteriaValue)}).map(function (d, idx) {
                              return (
                                <div
                                  key={idx}
                                  className="col container-sub-grid_detail"
                                  style={{ margin: 0, fontSize: 11 }}
                                  onClick={() => {

                                    setColorParam({
                                      id: val.id,
                                      color: d.color,
                                      name: d.name,
                                    });

                                    setDisplayParam({ status: true, id: d.id, id2: val1.id });



                                  }}
                                >
                                  <span>{d.name}</span>
                                  <div
                                    style={{
                                      backgroundColor: d.color,
                                      width: "75px",
                                    }}
                                    className="bar"
                                  ></div>

                                </div>
                              );
                            })}
                          </div>
                          <div className="row icons_details-grille">
                            <div className="col">
                              <div className="container-cercle-like_grille" > {val1?.CriteriaOption.filter((e) => e?.type === 'BONUS').length} </div>

                              <PopoverBonus val={val1?.CriteriaOption.filter((e) => e?.type === 'BONUS')} ic={key1} />
                            </div>
                            <div className="col">
                              <div className="container-cercle-dislike_grille"> {val1?.CriteriaOption.filter((e) => e?.type === 'BONUS').length} </div>
                              <Popovermalus val={val1?.CriteriaOption.filter((e) => e?.type === 'MALUS')} ic={key1} />
                            </div>
                            <div
                              style={{ backgroundColor: "#f3f2f5" }}
                              className="col container-of-icon-detail-grille"
                            >
                              <OverlayTrigger
                                trigger="click"
                                ref={overlayChatRef}
                                rootClose
                                placement="bottom-end"
                                overlay={popoverChat}
                              >
                                <img
                                  onClick={(() => { setCurrentDesc(val1?.description) })}
                                  src={iconChat}
                                />
                              </OverlayTrigger>
                            </div>

                          </div>

                          {displayParam.status && colorParam.id === val.id && displayParam.id2 === val1.id ? (
                            <>

                              {props.e.CriteriaGroup[idkey].Criteria.map((e) => e.id === displayParam.id2 && (

                                <div className="container-detail-sub-grid">

                                  {e.CriteriaValue.sort((a,b)=> {return (a.idCriteriaValue - b.idCriteriaValue)}).map((e1) => e1.id === displayParam.id && (

                                    <div
                                      className="detail-subgrid"
                                      style={{ borderColor: colorParam.color }}
                                    >

                                      <div style={{ fontSize: "11px", color: "black" }}>

                                        {e1.name}
                                      </div>
                                      <span style={{ fontSize: "9px", display: "block", maxHeight: 100, overflowY: "auto" }} >

                                        {e1.description}

                                      </span>

                                    </div>
                                  ))}
                                </div>
                              ))}
                            </>
                          ) : null}
                        </div>
                      )
                      )}

                    </div>

                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (<div
      className={clsx(
        { "detail-grille-container": isOpenDetailGrille },
        { "detail-grille-containe-close": closeAnimation }
      )}
    >
      {!props.elmineDivision &&
        <div
          className="left-side-detail-grille"
          onClick={() => {


            setCloseAnimation(true);

            setTimeout(() => {
              dispatch(closeDetailGrille());
            }, 2000);
          }}
        ></div>}
      <div className={!props.elmineDivision ? " right-side-detail-grille" : "side-detail-grille"}>
        <div className="container-topbar-of-callibrage">
          <div
            className="container-icon-arraw-left"
            onClick={() => {
              setCloseAnimation(true);

              setTimeout(() => {
                dispatch(closeDetailGrille());
              }, 2000);
            }}
          >
            <img src={iconRightArrow} />
          </div>
          {!props?.elmineDivision ? <p style={{ marginBottom: "0" }} > Détails grille :  <span >{datagrille?.grid?.name}</span> </p> : <p style={{ marginBottom: "0" }} > Details  grilles :  <span >{datagrille?.grid?.name}</span> </p>}

        </div>

        <div id="detail-grille-bottom-side">
          <div className="container-of-right-side">
          {(datagrille?.Attributs && datagrille?.Attributs?.length != 0) ?
          <>
            <div>
            <span className="section-names"> Critères </span>
              {datagrille?.grid?.CriteriaGroup && datagrille?.grid?.CriteriaGroup.map(function (val, idkey) {
                return (
                  <div>

                    <div className="detail-grille_title mb-2">
                      <span style={{ color: "#5800e2" }}>{val.name}</span>
                    </div>


                    {val?.Criteria.map((val1, key1) =>
                    (
                      <div
                        key={idkey}
                        className="row containers_detail-grille align-items-center mb-1"
                      >
                        <div
                          className="col-2 pr-0 pl-0"
                          style={{ maxWidth: "130px" }}
                          onClick={() =>

                            setDisplayParam({ status: false, id: 0 })

                          }
                        >
                          {val1.name}
                        </div>
                        <div className="col d-flex pr-0 pl-0">
                          {val1.CriteriaValue && val1.CriteriaValue.sort((a,b)=> {return (a.idCriteriaValue - b.idCriteriaValue)}).map(function (d, idx) {
                            return (
                              <div
                                key={idx}
                                className="container-sub-grid_detail"
                                style={{ margin: 0, fontSize: 11 }}
                                onClick={() => {
                                  setColorParam({
                                    id: val.id,
                                    color: d.color,
                                    name: d.name,
                                  });

                                  setDisplayParam({ status: true, id: d.id, id2: val1.id });


                                }}
                              >
                                <span>{d.name}</span>
                                <div
                                  style={{
                                    backgroundColor: d.color,
                                    width: "75px",
                                  }}
                                  className="bar"
                                ></div>

                              </div>
                            );
                          })}
                        </div>
                        <div className="row icons_details-grille">
                          <div className="col detail-grille_score pr-0 pl-0">
                            <div className="container-cercle-like_grille" > {val1?.CriteriaOption.filter((e) => e?.type === 'BONUS').length}  </div>

                            <PopoverBonus val={val1?.CriteriaOption.filter((e) => e?.type === 'BONUS')} ic={key1} />
                          </div>
                          <div className="col detail-grille_score pr-0 pl-0">
                            <div className="container-cercle-dislike_grille"> {val1?.CriteriaOption.filter((e) => e?.type === 'MALUS').length}  </div>
                            <Popovermalus val={val1?.CriteriaOption.filter((e) => e?.type === 'MALUS')} ic={key1} />
                          </div>
                          <div
                            className="col container-of-icon-detail-grille "
                          >
                            <OverlayTrigger
                              trigger="click"
                              ref={overlayChatRef}
                              rootClose
                              placement="bottom-end"
                              overlay={popoverChat}
                            >
                              <img
                                src={iconChat}
                                onClick={(() => { setCurrentDesc(val1?.description) })}
                              />
                            </OverlayTrigger>
                          </div>
                          <div
                            className="col container-of-icon-detail-grille"
                          >
                            <img
                              src={iconInfo}
                            />
                          </div>
                        </div>

                        {displayParam.status && colorParam.id === val.id && displayParam.id2 === val1.id ? (
                          <>

                            {datagrille?.grid?.CriteriaGroup[idkey].Criteria.map((e) => e.id === displayParam.id2 && (

                              <div className="container-detail-sub-grid">

                                {e.CriteriaValue.sort((a,b)=> {return (a.idCriteriaValue - b.idCriteriaValue)}).map((e1) => e1.id === displayParam.id && (

                                  <div
                                    className="detail-subgrid"
                                    style={{ borderColor: colorParam.color }}
                                  >

                                    <div style={{ fontSize: "12px", color: "black", fontWeight: 700 }}>

                                      {e1.name}
                                    </div>
                                    <span style={{ fontSize: "10px", display: "block", maxHeight: 100, overflowY: "auto" }} >

                                      {e1.description}

                                    </span>

                                  </div>
                                ))}
                              </div>
                            ))}
                          </>
                        ) : null}
                      </div>
                    )
                    )}

                  </div>

                )
              })}
            </div>
            <hr/>
            <div className="attribut-section-side">
        
        <> 
      <span className="section-names" > Attributs </span>
            {datagrille?.Attributs?.sort((a, b) => {
             return a?.Attribut?.name.localeCompare(b?.Attribut?.name, undefined, { sensitivity: 'accent' });
             }).map((attribut) => {
          //  const isExpanded = expandedAttributes[attribut?.Attribut.id];
                 return(
                  
               <div className="container-relationnel-attribut" >
              
              <div className="header-relationnel-attribut-text attribut1" title={attribut?.Attribut.name}>
              
               <div className="attr-title" >
             <span className="detail-grille_attribut-title mb-2"> 
              {attribut?.Attribut.name} </span> 
             </div>
              </div>
              
                   {/* {isExpanded && 
                  ( 
                   <>
                   {
                     attribut?.AttributValues?.slice(0, 2).map((values, index) => {
                       return (
                         <React.Fragment key={index}>
                           <div className="attribute-relationnel attribut1" title={values?.name}>
                             <span className="attr-title">{values?.name}</span>
                           </div>
                           {index === 1 && !showAllValues && attribut?.AttributValues?.length > 2 && (
                           <div className="attribute-relationnel attribut1">
                             <img src={arrowdown} style={{width: "15px"}} alt="show" onClick={() => setShowAllValues(true)}/>
                             
                             </div>
                           )}
                         </React.Fragment>
                       );
                     })
                   }

             {showAllValues &&
               attribut?.AttributValues?.slice(2).map((values, index) => {
                 return (
                   <div className="attribute-relationnel attribut1" key={index} title={values?.name}>
                     <span className="attr-title">{values?.name}</span>
                   </div>
                 );
               })
             }

             {showAllValues && 
               attribut?.AttributValues?.length > 2 && (
                 <div className="attribute-relationnel attribut1">
                 <img  src={arrowupSelected} alt="hide" onClick={() => setShowAllValues(false)}/>
                 </div>
               )
             }
                   </>
               
                   )
                   
                 } */}
                   </div>
                 )
             })
           }
        </>

</div>
            </>
            :
            <div>
            <span className="section-names"> Critères </span>
              {datagrille?.grid?.CriteriaGroup && datagrille?.grid?.CriteriaGroup.map(function (val, idkey) {
                return (
                  <div>

                    <div className="detail-grille_title mb-2">
                      <span style={{ color: "#5800e2" }}>{val.name}</span>
                    </div>


                    {val?.Criteria.map((val1, key1) =>
                    (
                      <div
                        key={idkey}
                        className="row containers_detail-grille align-items-center mb-1"
                      >
                        <div
                          className="col-2 pr-0 pl-0"
                          style={{ maxWidth: "130px" }}
                          onClick={() =>

                            setDisplayParam({ status: false, id: 0 })

                          }
                        >
                          {val1.name}
                        </div>
                        <div className="col d-flex pr-0 pl-0">
                          {val1.CriteriaValue && val1.CriteriaValue.sort((a,b)=> {return (a.idCriteriaValue - b.idCriteriaValue)}).map(function (d, idx) {
                            return (
                              <div
                                key={idx}
                                className="container-sub-grid_detail"
                                style={{ margin: 0, fontSize: 11 }}
                                onClick={() => {
                                  setColorParam({
                                    id: val.id,
                                    color: d.color,
                                    name: d.name,
                                  });

                                  setDisplayParam({ status: true, id: d.id, id2: val1.id });


                                }}
                              >
                                <span>{d.name}</span>
                                <div
                                  style={{
                                    backgroundColor: d.color,
                                    width: "75px",
                                  }}
                                  className="bar"
                                ></div>

                              </div>
                            );
                          })}
                        </div>
                        <div className="row icons_details-grille">
                          <div className="col detail-grille_score pr-0 pl-0">
                            <div className="container-cercle-like_grille" > {val1?.CriteriaOption.filter((e) => e?.type === 'BONUS').length}  </div>

                            <PopoverBonus val={val1?.CriteriaOption.filter((e) => e?.type === 'BONUS')} ic={key1} />
                          </div>
                          <div className="col detail-grille_score pr-0 pl-0">
                            <div className="container-cercle-dislike_grille"> {val1?.CriteriaOption.filter((e) => e?.type === 'MALUS').length}  </div>
                            <Popovermalus val={val1?.CriteriaOption.filter((e) => e?.type === 'MALUS')} ic={key1} />
                          </div>
                          <div
                            className="col container-of-icon-detail-grille "
                          >
                            <OverlayTrigger
                              trigger="click"
                              ref={overlayChatRef}
                              rootClose
                              placement="bottom-end"
                              overlay={popoverChat}
                            >
                              <img
                                src={iconChat}
                                onClick={(() => { setCurrentDesc(val1?.description) })}
                              />
                            </OverlayTrigger>
                          </div>
                          <div
                            className="col container-of-icon-detail-grille"
                          >
                            <img
                              src={iconInfo}
                            />
                          </div>
                        </div>

                        {displayParam.status && colorParam.id === val.id && displayParam.id2 === val1.id ? (
                          <>

                            {datagrille?.grid?.CriteriaGroup[idkey].Criteria.map((e) => e.id === displayParam.id2 && (

                              <div className="container-detail-sub-grid">

                                {e.CriteriaValue.sort((a,b)=> {return (a.idCriteriaValue - b.idCriteriaValue)}).map((e1) => e1.id === displayParam.id && (

                                  <div
                                    className="detail-subgrid"
                                    style={{ borderColor: colorParam.color }}
                                  >

                                    <div style={{ fontSize: "12px", color: "black", fontWeight: 700 }}>

                                      {e1.name}
                                    </div>
                                    <span style={{ fontSize: "10px", display: "block", maxHeight: 100, overflowY: "auto" }} >

                                      {e1.description}

                                    </span>

                                  </div>
                                ))}
                              </div>
                            ))}
                          </>
                        ) : null}
                      </div>
                    )
                    )}

                  </div>

                )
              })}
            </div>
}
          </div>
        </div>
      </div>
    </div>)
  );
};

export default DetailGrille;
